import Modal from 'admin/shared-components/Modal/Modal';

export type ConfirmEmailChangeModalProps = {
  closeModal: () => void;
  isOpen: boolean;
  options: {
    newEmail: string;
    oldEmail: string;
    onConfirm: () => void | Promise<void>;
    onCancel: () => void;
  };
};

const ModalContent = ({ closeModal, options, isOpen }: ConfirmEmailChangeModalProps) => {
  const handleConfirm = () => {
    closeModal();
    options.onConfirm();
  };

  const handleCancel = () => {
    options.onCancel();
    closeModal();
  };

  return (
    <Modal
      isOpen={isOpen}
      closeButton="Cancel"
      onSuccess={handleConfirm}
      onClose={handleCancel}
      canClose
      header="Confirm Email Change"
      doneButton="I Understand"
      isWarningButtonPresent={true}
      modalSize="small"
      body={`The email address will be updated from ${options.oldEmail} to ${options.newEmail} \n Once updated, the new email address will be required for the user’s future logins.`}
    />
  );
};

export default ModalContent;
